import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import MailInviteContent from "../../components/MailInviteContent/MailInviteContent";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { HiOutlineMail } from "react-icons/hi";
import styles from "./MailInviteModal.module.css";

const MailInviteModal = ({ mode = "send", role = "parent" }) => {
  const dispatch = useDispatch();
  const isEdit = mode === "edit";
  const isStaff = role === "staff";
  const salutation = isStaff ? "Hello Staff" : "Hello Parent";

  const defaultTemplate = `
${salutation},

Welcome to {{schoolName}}!
{{schoolName}} has invited you on the Illumine app.

It helps parents stay connected with their child throughout the day.
It only takes two steps to get started.

Instructions:
1. Download the Illumine app from the Apple App Store or Google Play.
   Get it on Google Play: https://play.google.com
   Get it on AppStore: https://apps.apple.com

Or

Open in Web: https://school.illumine.app

2. Login using your registered mobile number.

Email: {{email}}
Password: {{password}}

Quick things to do after sign-in:
Go to your profile and add your photo. Make sure your contact info is updated.

Questions? Contact us at info@illumine.app
Thanks,
{{schoolName}}
`;

  const contentRef = useRef();

  const handleRestore = () => {
    contentRef.current?.resetToDefault?.();
  };

  const handleSave = () => {
    const content = contentRef.current?.getContent?.();
    console.log("Saved content:", content);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.wrapper}>
        <div className={styles.inside}>
        <div className={styles.headerRow}>
          <HeadingAndIcon
            icon={<HiOutlineMail size={18} />}
            heading={`${isEdit ? "Edit" : "Send"} Mail Invite`}
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.contentScroll}>
          {isEdit && (
            <div className={styles.instructionsBox}>
              <p className={styles.instructionsTitle}>INSTRUCTIONS:</p>
              <p>Make sure you use each of these tags in your email</p>
              <div className={styles.tagsRow}>
                <code>{"{{password}}"}</code>
                <code>{"{{studentName}}"}</code>
                <code>{"{{email}}"}</code>
                <code>{"{{schoolName}}"}</code>
              </div>
            </div>
          )}

          <MailInviteContent
            ref={contentRef}
            isEdit={isEdit}
            defaultTemplate={defaultTemplate}
            schoolName="{{schoolName}}"
            email="{{email}}"
            password="{{password}}"
            salutation={salutation}
          />
        </div>

        {isEdit && (
          <div className={styles.footer}>
            <SaveAndCancel
              cancelLabel="Restore to default"
              onCancel={handleRestore}
              onSave={handleSave}
            />
          </div>
        )}
      </div>
    </div></div>
  );
};

export default MailInviteModal;
